import { render, staticRenderFns } from "./CRScoringExplained.vue?vue&type=template&id=1a225d30"
import script from "./CRScoringExplained.vue?vue&type=script&lang=js"
export * from "./CRScoringExplained.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports